import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';

@Component({
  selector: 'adahi-contact-us',
  templateUrl: './contact-us.component.html'
})
export class ContactUsComponent implements OnInit {
  
  appSettings: IAppConfig;
  contactUsEmail:string;
  contactusKsaNumber:string;
  whatsappNumber: string;
  callCenterNumber: string;

  constructor() {
    
    this.appSettings = AppConfig.settings;
    this.contactUsEmail = this.appSettings.contactUsEmail;
    this.contactusKsaNumber = this.appSettings.contactusKsaNumber;
    this.whatsappNumber = this.appSettings.contactusKsaNumber.replace('-','').replace('+','');
    this.callCenterNumber = this.appSettings.callCenterksa;
  }

  ngOnInit() {
  }

}
